[
    {
       "name":"Test essential cookie",
       "type":"essential",
       "domain":"company.com",
       "platform":"Company",
       "descriptions":[
          {
             "language":"en_US",
             "text":"Test cookies for test company"
          },
          {
             "language":"nb_NO",
             "text":"Test cookies for test company(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"Test cookies for test company(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"Test cookies for test company(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"Test cookies for test company(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"Test cookies for test company(de_DE)"
          }
       ],
       "expirations":[
          {
             "language":"en_US",
             "text":"4 days"
          },
          {
             "language":"nb_NO",
             "text":"4 days(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"4 days(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"4 days(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"4 days(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"4 days(de_DE)"
          }
       ]
    },
    {
       "name":"Test another essential cookie",
       "type":"essential",
       "domain":"monsido.com",
       "platform":"Acquia Optimize",
       "descriptions":[
          {
             "language":"en_US",
             "text":"Test cookies for test company"
          },
          {
             "language":"nb_NO",
             "text":"Test cookies for test company(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"Test cookies for test company(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"Test cookies for test company(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"Test cookies for test company(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"Test cookies for test company(de_DE)"
          }
       ],
       "expirations":[
          {
             "language":"en_US",
             "text":"4 months"
          },
          {
             "language":"nb_NO",
             "text":"4 months(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"4 months(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"4 months(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"4 months(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"4 months(de_DE)"
          }
       ]
    },
    {
       "name":"Test preference cookie",
       "type":"personalisation",
       "domain":"monsido.dk",
       "platform":"Acquia Optimize",
       "descriptions":[
          {
             "language":"en_US",
             "text":"Test cookies for test company"
          },
          {
             "language":"nb_NO",
             "text":"Test cookies for test company(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"Test cookies for test company(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"Test cookies for test company(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"Test cookies for test company(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"Test cookies for test company(de_DE)"
          }
       ],
       "expirations":[
          {
             "language":"en_US",
             "text":"4 months"
          },
          {
             "language":"nb_NO",
             "text":"4 months(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"4 months(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"4 months(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"4 months(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"4 months(de_DE)"
          }
       ]
    },
    {
       "name":"Test basic cookie",
       "type":"basic",
       "domain":"software.com",
       "platform":"Software",
       "descriptions":[
          {
             "language":"en_US",
             "text":"Testing basic cookie"
          },
          {
             "language":"nb_NO",
             "text":"Testing basic cookie(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"Testing basic cookie(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"Testing basic cookie(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"Testing basic cookie(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"Testing basic cookie(de_DE)"
          }
       ],
       "expirations":[
          {
             "language":"en_US",
             "text":"24 hours"
          },
          {
             "language":"nb_NO",
             "text":"24 hours(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"24 hours(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"24 hours(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"24 hours(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"24 hours(de_DE)"
          }
       ]
    },
    {
       "name":"Test marketing cookie",
       "type":"marketing",
       "domain":"company",
       "platform":"Company",
       "descriptions":[
          {
             "language":"en_US",
             "text":"Testing marketing cookies"
          },
          {
             "language":"nb_NO",
             "text":"Testing marketing cookies(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"Testing marketing cookies(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"Testing marketing cookies(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"Testing marketing cookies(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"Testing marketing cookies(de_DE)"
          }
       ],
       "expirations":[
          {
             "language":"en_US",
             "text":"1 day"
          },
          {
             "language":"nb_NO",
             "text":"1 day(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"1 day(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"1 day(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"1 day(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"1 day(de_DE)"
          }
       ]
    },
    {
       "name":"Test statistics cookie",
       "type":"analytics",
       "domain":"statistics",
       "platform":"Demo",
       "descriptions":[
          {
             "language":"en_US",
             "text":"Basic data collection"
          },
          {
             "language":"nb_NO",
             "text":"Basic data collection(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"Basic data collection(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"Basic data collection(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"Basic data collection(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"Basic data collection(de_DE)"
          }
       ],
       "expirations":[
          {
             "language":"en_US",
             "text":"7 days"
          },
          {
             "language":"nb_NO",
             "text":"7 days(nb_NO)"
          },
          {
             "language":"nl_NL",
             "text":"7 days(nl_NL)"
          },
          {
             "language":"da_DK",
             "text":"7 days(da_DK)"
          },
          {
             "language":"es_ES",
             "text":"7 days(es_ES)"
          },
          {
             "language":"de_DE",
             "text":"7 days(de_DE)"
          }
       ]
    }
 ]